module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-step"
  }, [_c('h1', {
    staticClass: "ls-title-1 ls-color-theme ls-lg-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('wizard.welcome')))]), _vm._v(" "), _c('h2', {
    staticClass: "ls-title-5 ls-lg-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('wizard.initial_configs')))]), _vm._v(" "), _c('router-link', {
    staticClass: "ls-btn-primary",
    attrs: {
      "to": {
        name: 'steps'
      },
      "title": _vm.$t('wizard.btn_lets_start')
    }
  }, [_vm._v(_vm._s(_vm.$t('wizard.btn_lets_start')))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7143951b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/wizard/Main.vue
// module id = 800
// module chunks = 1